import { useContext } from 'react';
import { useOptionalReseller } from '@/reseller/resellerContext';
import { AuthContext, type AuthContextValue, type CurrentOperator } from './authContextValue';

export type { AuthContextValue, CurrentOperator } from './authContextValue';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}

/**
 * The signed-in member. Inside the shell this is `ResellerProvider`'s operator — tmm-api's
 * LIVE role wins over the token's (H §4.4); outside it, the token's hint.
 */
export function useCurrentOperator(): CurrentOperator | null {
  const auth = useAuth();
  const reseller = useOptionalReseller();
  return reseller?.operator ?? auth.operator;
}

/** OWNER or ADMIN — may write. STAFF is read-only everywhere. Presentation only. */
export function useCanWrite(): boolean {
  return useCurrentOperator()?.canWrite === true;
}

/** OWNER — sees the GHL integration. Presentation only. */
export function useIsOwner(): boolean {
  return useCurrentOperator()?.isOwner === true;
}
